export const socialsData = {
    github: 'https://github.com/alkaria999',
    facebook: 'https://www.facebook.com/profile.php?id=100087281281029',
    linkedIn: 'https://www.linkedin.com/in/alkaria-mandal',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}